import MyShipments from './myShipments';

export default MyShipments;
